<template>
    <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="97.017" viewBox="0 0 372 97.017">
        <path id="Path_5s"
              data-name="Path 5"
              d="M0,20A20,20,0,0,1,20,0H352a20,20,0,0,1,20,20l-.371,72.25-27.2,2.662s-27.808,2.379-44.5,2.079c-32.547-.585-58.112-1.331-58.112-1.331l-36.9-2.386-37.333-3.026L126.79,85.93,84.177,81.308s-31.888-2.508-43.04-2C22.825,80.139.009,85.772.009,85.772Z" fill="#ec4b1d"
              :fill="color"/>
    </svg>
</template>

<script>
export default {
    name: "CardHead",
    data() {
        return {
        };
    },
    props: {
        color: {
            type: String,
            default: '#EC4B1D',
        },
    }
}
</script>
<style scoped>
    svg{
        z-index: 0;
        top: 55px;
    }
</style>



// WEBPACK FOOTER //
// src/components/V2/popup-chat/CardHead.vue